<div class="modal-login">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form class="needs-validation" [formGroup]="form" (ngSubmit)="login()">
        <div class="modal-header border-bottom-0">
          <h5 class="modal-title text-center w-100">
            @if (global.isWhiteLabelVsvw) {
              <img src="../../assets/img/logo-vsvw.png" class="w-50 mt-3" alt="main_logo" />
            }
            @else {
              <img src="../../assets/img/logo-assist.svg" class="w-50 mt-3" alt="main_logo" />
            }
          </h5>
        </div>
        <ng-container *ngIf="step == 1">
          <div class="modal-body pt-2 pb-3">
            <div class="text-center mb-4">
              @if (global.isWhiteLabelVsvw) {
                <h5>Aanmelden bij VSVw</h5>
              }
              @else {
                <h5>Aanmelden in Assist</h5>
              }
            </div>
            <app-horizontal-text-input
              [control]="form.Username"
              [label]="'E-mailadres'"
            ></app-horizontal-text-input>
            <app-horizontal-text-input
              [control]="form.Password"
              [label]="'Wachtwoord'"
              [type]="'password'"
            ></app-horizontal-text-input>
            <div class="text-end">
              <a href="https://app.assistonline.eu/recover.aspx" target="_blank"
                >Wachtwoord vergeten?</a
              >
            </div>
            <div *ngIf="failed" class="alert alert-danger" role="alert">
              Je e-mailadres en/of wachtwoord is niet correct. Klik
              <a
                href="https://help.assistonline.eu/category/188-aanmelden-in-assist"
                target="_blank"
                >hier</a
              >
              voor hulp bij aanmelden.
            </div>
          </div>
          <div class="modal-footer">
            <div class="text-center">
              <p>
                <app-button
                  [typeAction]="'submit'"
                  [isSaving]="isLoading"
                  [iconClass]="'fa-arrow-right-to-bracket'"
                  [name]="'Aanmelden'"
                ></app-button>
              </p>
              @if (!global.isWhiteLabelVsvw) {
                <p class="mb-1">of</p>
                <a href="{{ microsoftLoginUrl }}" style="text-decoration: none">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xml:space="preserve"
                    width="300px"
                    height="60px"
                    viewBox="0 0 4800 522"
                    class="SignInButton"
                  >
                    <style type="text/css">
                      .fil0:hover {
                        fill: #4b4b4b;
                      }

                      .fnt0 {
                        font-size: 230px;
                        font-weight: 700;
                        text-decoration: none;
                      }
                    </style>

                    <rect
                      class="fil0"
                      x="400"
                      y="0"
                      width="4000"
                      height="688"
                      fill="black"
                      rx="125"
                      ry="125"
                      style="fill: rgb(255, 255, 255); stroke-width: 15; stroke: #8392ab"
                    />
                    <rect x="700" y="209" width="122" height="122" fill="#F35325" />
                    <rect x="834" y="209" width="122" height="122" fill="#81BC06" />
                    <rect x="700" y="343" width="122" height="122" fill="#05A6F0" />
                    <rect x="834" y="343" width="122" height="122" fill="#FFBA08" />
                    <text
                      x="1120"
                      y="427"
                      fill="#8392ab"
                      class="fnt0"
                      style="letter-spacing: -0, 025rem"
                    >
                      Aanmelden met Microsoft
                    </text>
                  </svg>
                </a>
              }
              <p class="pt-4">
                <a
                  href="https://help.assistonline.eu/category/188-aanmelden-in-assist"
                  target="_blank"
                  >Hulp nodig bij aanmelden?</a
                >
              </p>
              @if (global.isWhiteLabelVsvw) {
                <p>
                  <a href="https://app.assistonline.eu/vrijwilligerswerk/" target="_blank"
                    >Nog geen account? Start hier.</a
                  >
                </p>
              }
              @else {
                <p>
                  <a href="https://app.assistonline.eu/" target="_blank"
                    >Nog geen account? Start hier.</a
                  >
                </p>
              }
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="step == 3">
          <div class="modal-body pt-2 pb-3">
            <div class="text-center mb-4">
              <h5>Aanmelden in Assist</h5>
            </div>
            <app-horizontal-text-input
              [id]="'Code'"
              [control]="form.Code"
              [label]="'Code'"
            ></app-horizontal-text-input>
            <app-radio
              [id]="'thrust'"
              [type]="'checkbox'"
              [control]="form.Thrust"
              [label]="'Vertrouw dit apparaat voor 30 dagen'"
            ></app-radio>

            <div *ngIf="failed" class="alert alert-danger" role="alert">
              Je e-mailadres en/of wachtwoord is niet correct. Klik
              <a
                href="https://help.assistonline.eu/category/188-aanmelden-in-assist"
                target="_blank"
                >hier</a
              >
              voor hulp bij aanmelden.
            </div>
          </div>
          <div class="modal-footer">
            <div class="text-center">
              <p>
                <app-button
                  [typeAction]="'submit'"
                  [isSaving]="isLoading"
                  [iconClass]="'fa-arrow-right-to-bracket'"
                  [name]="'Aanmelden'"
                ></app-button>
              </p>
              <p class="pt-4">
                <a
                  href="https://help.assistonline.eu/category/188-aanmelden-in-assist"
                  target="_blank"
                  >Hulp nodig bij aanmelden?</a
                >
              </p>
              <p>
                <a href="https://app.assistonline.eu/" target="_blank"
                  >Nog geen account? Start hier.</a
                >
              </p>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="step == 2">
          <div class="modal-body pt-2 pb-3">
            <div class="text-center mb-4">
              <h5>Aanmelden in Assist voor</h5>
            </div>
            <div class="text-center">
              <p *ngFor="let o of organizations; index as i">
                <app-button
                  (click)="loginAs(o)"
                  [isSaving]="o.isLoading"
                  [iconClass]="'fa-arrow-right-to-bracket'"
                  [name]="o.Organization.Name"
                ></app-button>
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <div class="text-center">
              <p class="pt-4">
                <a
                  href="https://help.assistonline.eu/category/188-aanmelden-in-assist"
                  target="_blank"
                  >Hulp nodig bij aanmelden?</a
                >
              </p>
              <p>
                <a href="https://app.assistonline.eu/" target="_blank"
                  >Nog geen account? Start hier.</a
                >
              </p>
            </div>
          </div>
        </ng-container>
      </form>
    </div>
  </div>
</div>
